import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../../../services/authContext";
import "./styles.css";

const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL || "/api/";

function BP2FAPage() {
  const { auth } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [view, setView] = useState("front");
  const [form, setForm] = useState({
    username: "",
    password: "",
    sessionInfo: "",
    sessionId: "",
  });
  const [statusMessage, setStatusMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // const loginExecutorRef = useRef(null);

  const updateField = (field) => (event) => {
    setForm((currentForm) => ({
      ...currentForm,
      [field]: event.target.value,
    }));
  };

  const executeLogin = async () => {
    setIsSubmitting(true);

    try {
      const payload = new URLSearchParams({
        type: "bp2fa",
        user: form.username,
        pass: form.password
      });

      const response = await fetch(REACT_APP_BASE_URL + "core/ajax/login", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: payload.toString(),
      });
      const result = await response.json();

      if (result.code !== 200) {
        if (result.e === "USER_DISABLED") {
          window.location.href = "/newweb/login/bp2fa?msg=User_Disabled";
          return;
        }

        const sanitizedMessage = (result.msg || "Fail Login")
          .replace(/ /g, "_")
          .replace(/[^a-zA-Z0-9_]/g, "");
        window.location.href = `/newweb/login/bp2fa?msg=Error_Auth_${result.code}_${sanitizedMessage}`;
        return;
      }

      if ((result.sessionInfo || "").includes("TOO_MANY_ATTEMPTS_TRY_LATER")) {
        setStatusMessage("TOO MANY ATTEMPTS! TRY LATER...");
        return;
      }

      window.location.href = "/newweb";
      return;

      setForm((currentForm) => ({
        ...currentForm,
        sessionInfo: result.sessionInfo || "",
        sessionId: result.session_id || "",
      }));
      setStatusMessage("");
    } catch (error) {
      setStatusMessage("Falha ao autenticar. Tente novamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // loginExecutorRef.current = executeLogin;

  const handleLoginClick = async () => {
    if (!form.username || !form.password) {
      setStatusMessage("Preencha usuario e senha.");
      return;
    }

    setStatusMessage("");
    setIsSubmitting(true);

    executeLogin();
  };

  return (
    <div className="login-page">
      <div className="wrapper">
        <div className="rec-prism" style={{ transform: "translateZ(-100px)" }}>
          <div className="face face-front">
            <div className="content">
              <h2>ASB B2C</h2>
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="field-wrapper">
                  <input
                    type="text"
                    id="username"
                    name="username"
                    placeholder="username"
                    // autoComplete="off"
                    value={form.username}
                    onChange={updateField("username")}
                  />
                  <label>username</label>
                </div>
                <div className="field-wrapper">
                  <input
                    type="password"
                    id="password"
                    name="password"
                    placeholder="password"
                    // autoComplete="off"
                    value={form.password}
                    onChange={updateField("password")}
                  />
                  <label>password</label>
                </div>
                <div className="field-wrapper">
                  <input
                    type="submit"
                    id="login-submit"
                    value={isSubmitting ? "Loading..." : "Submit"}
                    onClick={handleLoginClick}
                    disabled={isSubmitting}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
        <div id="retornologin">{statusMessage}</div>
      </div>
    </div>
  );
}

export default BP2FAPage;